import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareDeploymentsClassicRoute: InvariantJiraRoute = {
	name: 'software-deployments-classic',
	path: '/jira/software/c/projects/:projectKey/deployments',
};
